import { Component, OnInit } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ItemSidebar } from 'src/app/services/config-service/config-service.service';
import { LoginService, UserInfo } from 'src/app/services/login/login.service';
import { ModalServiceService } from 'src/app/services/modal-service/modal-service.service';

const SIDEBAR_CONFIG: ItemSidebar[] = [
  { label: 'sidebar.dashboard', url: 'dashboard', icon: 'bi bi-kanban', icon_active: 'bi bi-kanban', allow: ['3', '1', '2'] },
  { label: 'sidebar.fatture', url: 'invoices', icon: 'bi bi-file-earmark', icon_active: 'bi bi-file-earmark-fill', allow: ['3', '1', '2'] },
  { label: 'sidebar.configurazione', url: 'configuration', icon: 'bi bi-gear', icon_active: 'bi bi-gear-fill', allow: ['3', '1', '2'] },
  { label: 'sidebar.utenti', url: 'users', icon: 'bi bi-person', icon_active: 'bi bi-person-fill', allow: ['3', '1'] },
  { label: 'sidebar.stats', url: 'stats', icon: 'bi bi-graph-up', icon_active: 'bi bi-graph-up', allow: ['3'] }
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  userInfo : UserInfo | undefined;
  currentUser: UserInfo | undefined;
  _userConfigSidebar: ItemSidebar[] = [];
  tooltipVersion: string = "";

  public invoiceMode = false;

  constructor(private loginService: LoginService, public router: Router, public translate: TranslateService,
    private modalService: ModalServiceService) {
    // // console.log(router);
    // // console.log(router.getCurrentNavigation()?.finalUrl?.root.children.primary.segments[1].path);
    this.router.events.subscribe((event: Event) => {
        if (event instanceof NavigationEnd) { 
            if((event.url=="/main/invoices/new") || (event.url=="/main/invoices/edit"))
                this.invoiceMode=true;
            else
                this.invoiceMode=false;
            if(event.url=='/main/invoices')
                this.refreshCurrentUser();
        }
        
    });
  }


  async ngOnInit(): Promise<void> {
    //console.log("sidebar");
    this.userInfo = JSON.parse(localStorage.getItem("einvuser") || "");

    this._userConfigSidebar = SIDEBAR_CONFIG.filter((item) => item.allow.includes(this.userInfo!.role));
    
    //tooltip versione
    let responseVersion = await this.loginService.getVersion();
    if (responseVersion.success){
      this.tooltipVersion =  'version ' + responseVersion.data!.version + ' | ' + responseVersion.data!.date;
    }
  }

  async refreshCurrentUser(){
     //this.currentUser = await this.loginService.getSessionUserInfo();
  }

  changeLanguage(language: any){
    this.translate.setDefaultLang(language);
  }

  async logout(){
    let res = await this.loginService.logout();
    if(res.success){
      localStorage.clear();
      this.router.navigate(['../Login']);
    }
  }

  optima() {
    this.router.navigate(['/OptimaSmart']);
  }

  resetSessionUser(url : string){
    if(!this.router.url.includes(url)){
      this.loginService.setSessionUserInfo(this.userInfo!);
    }
  }

  openChangeLog(){
    this.modalService.openChangeLog();
  }

}
